<template>
  <v-container fluid>

    <LoadingModal :is-loading="isLoading" custom-text="Идет загрузка"/>

    <v-row>
      <div class='header'>
        <h2>Новости</h2>
      </div>

      <div class='horizontal-rule' />

      <v-container v-if="!failedToLoad">
        <v-row class="justify-start">
            <v-pagination
                v-model="page"
                :length="maxPage + 1"
                :total-visible="7"
            ></v-pagination>
        </v-row>
      </v-container>

      <v-col offset-sm='3' class='pa-0 mt-4' sm='6'>
        <v-card class='mb-4' tile v-for='(item, index) in news' :key='index'>
          <div v-if='isAdmin'>
            <v-btn class='float-right' @click='deleteThisNew(item.id)' icon>
              <v-icon color='red'>mdi-close-circle</v-icon>
            </v-btn>
            <v-btn class='float-right' @click='updateThisNew(item)' icon>
              <v-icon color='primary'>mdi-pencil-circle</v-icon>
            </v-btn>
          </div>
          <v-card-title class='text-break'>
            {{ item.title }}
          </v-card-title>
          <v-card-subtitle v-if='item.author' class='text-break'>{{ item.author }}</v-card-subtitle>
          <v-card-text class='text-break'>
            {{ item.content }}
          </v-card-text>
          <v-card-text>
            Дата публикации: {{item.createAt}}
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog
      v-model='showModal'
      fullscreen
      :scrim='false'
      transition='dialog-bottom-transition'
    >
      <v-card tile>
        <v-toolbar
          tile
          dark
          color='primary'

        >
          <v-btn
            icon
            dark
            @click='showModal = false'
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Редактирование новости</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <CreationForm @updateNew='updateNews' :new-to-edit='newToEdit' :is-updating='true' :key='newToEdit.id'
                      class='pa-5 mt-0' />
      </v-card>
    </v-dialog>

  </v-container>
</template>


<script>
import { deleteNew, fetchNews } from '@/services/newAPI';
import CreationForm from '@/components/NewCreationPageComponents/CreationForm';
import LoadingModal from "@/components/UI/LoadingModal";

export default {
  name: 'NewsPage',

  components: { CreationForm, LoadingModal },

  data() {
    return {
      news: [],
      showModal: false,
      newToEdit: {},

      page: 1,
      maxPage: 0,

      isLoading: false,
      failedToLoad: false,
    };
  },

  computed: {
    isAdmin() {
      return this.$store.getters.getIsViewAdminPanel;
    },
  },

  methods: {
    async deleteThisNew(id) {
      await deleteNew(id);
      this.news = this.news.filter(item => item.id !== id);
      if(this.news.length === 0 && (this.page - 1) !== 0) this.page--
    },

    async updateThisNew(item) {
      this.showModal = true;
      this.newToEdit = item;
    },

    async updateNews() {
      this.showModal = false;
      this.isLoading = true
      await fetchNews(null, null, null, this.page - 1)
          .then((data) => {
            this.news = data.body
            this.maxPage = data.maxPage
          })
          .catch((e) => {
            this.maxPage = 0
            if (e.response.status === 404) this.failedToLoad = true
          }).finally(() => this.isLoading = false);
    },
  },
  async mounted() {
    this.isLoading = true
    await fetchNews(null, null, null, this.page - 1)
        .then((data) => {
          this.news = data.body
          this.maxPage = data.maxPage
        })
        .catch((e) => {
          this.maxPage = 0
          if (e.response.status === 404) this.failedToLoad = true
        }).finally(() => this.isLoading = false);
  },

  watch: {
    async page() {
      this.isLoading = true
      await fetchNews(null, null, null, this.page - 1)
          .then((data) => {
            this.news = data.body
            this.maxPage = data.maxPage
          })
          .catch((e) => {
            this.maxPage = 0
            if (e.response.status === 404) this.failedToLoad = true
          }).finally(() => this.isLoading = false);
    }
  }
};
</script>

<style scoped>

</style>